<template>
  <rest-list :payload="fetchEndpoint" @dataLoaded="setData($event)">
    <template v-if="data[0]">
      <rest-list-column
        prop="type"
        :title="$t('CampaignChannelAnalytics_Table_Bounces')"
      />
      <rest-list-column
        prop="metrics[0].value"
        :title="$t('CampaignChannelAnalytics_Table_Amount')"
        :filter-input="false"
        :width="200"
      />
    </template>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import moment from 'moment'

export default {
  name: 'Bounces',

  components: { RestListColumn, RestList },

  data() {
    return {
      data: [],
      date_from: this.$route.query.date_from || '',
      date_to: this.$route.query.date_to || ''
    }
  },

  mounted() {
    EventBus.$on('common/components/dashboard/DateFilter:onChange', event => {
      this.date_from = moment(event.start).format('YYYY-MM-DD')
      this.date_to = moment(event.end).format('YYYY-MM-DD')
    })
  },

  computed: {
    campaignId() {
      return this.$route.query.id || null
    },

    channel() {
      return this.$route.query.channel || null
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}/analytics/${this.channel}/bounces`,
        params: {
          date_from: this.date_from,
          date_to: this.date_to
        }
      })
    }
  },

  methods: {
    setData(event) {
      this.data = event
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/analytics/components/Bounces.vue